import type { Resource } from '@/db/types'

// A PR walkthrough is a Page Prime writes when the owner asks, labelled
// `pr` = "owner/repo#N". The review screen finds the newest one by that label.

export const prLabel = (repo: string, number: number) => `${repo}#${number}`

/** The newest live Page labelled for this pull request, or undefined. */
export const findWalkthrough = <T extends Resource>(
  pages: T[] | undefined,
  repo: string,
  number: number,
): T | undefined => {
  const want = prLabel(repo, number)
  let best: T | undefined
  for (const p of pages ?? []) {
    if (p.kind !== 'Page' || p.deleted_at || p.labels?.pr !== want) continue
    if (!best || p.created_at > best.created_at) best = p
  }
  return best
}
